interface FeaturedListCardsProps {
    el: HTMLDivElement;
    props: {
        itemSelector: string;
        loadButtonSelector: string;
        initialItems: number;
        itemsPerPage: number;
    };
}

const ITEM_SELECTOR = '.card-container > *';
const LOAD_BUTTON_SELECTOR = '.featured-list-load-button';
const INITIAL_ITEMS = 3;
const ITEMS_PER_PAGE = 3;

const HIDDEN_CLASS = 'hidden';

const FeaturedListCards = ({ el, props }: FeaturedListCardsProps): void => {
    const {
        itemSelector = ITEM_SELECTOR,
        loadButtonSelector = LOAD_BUTTON_SELECTOR,
        initialItems = INITIAL_ITEMS,
        itemsPerPage = ITEMS_PER_PAGE,
    } = props;


    const itemEls = el.querySelectorAll(`${itemSelector}`);
    const loadMoreButtonEl = el.querySelector(`${loadButtonSelector}`);

    if (!loadMoreButtonEl || !itemEls) {
        // stop the script from executing if required elements doesn't exist
        return;
    }

    if (itemEls.length > initialItems) {
        // count the itemSelectors
        // when the page is loaded make sure that only the initialItems amount are shown
        for (let i = initialItems; i < itemEls.length; i += 1) {
            itemEls[i].classList.add(HIDDEN_CLASS);
        }
        // intentionally keep here just to show if need remaining items later on
        // loadMoreButtonEl.innerHTML = `LOAD MORE (+${itemEls.length - initialItems})`;
    } else {
        loadMoreButtonEl?.classList.add(HIDDEN_CLASS);
    }
    const showMoreRows = (): void => {
        const hiddenItemEls = el.querySelectorAll(`${itemSelector}.${HIDDEN_CLASS}`);
        // check if the amount of hidden items are less than items per page, use the amount of hidden items left.
        const loopLength = hiddenItemEls.length < itemsPerPage ? hiddenItemEls.length : itemsPerPage;
        for (let i = 0; i < loopLength; i += 1) {
            hiddenItemEls[i].classList.remove(HIDDEN_CLASS);
        }
        // check if the amount of hidden items AFTER the click, if there's none, hide the button.
        const hiddenItemElsAfterLoad = el.querySelectorAll(`${itemSelector}.${HIDDEN_CLASS}`);
        if (hiddenItemElsAfterLoad.length === 0) {
            loadMoreButtonEl.classList.add(HIDDEN_CLASS);
        }
        // intentionally keep here just to show if need remaining items later on
        // else {
        //     loadMoreButtonEl.innerHTML = `LOAD MORE (+${hiddenItemElsAfterLoad.length})`;
        // }
    };

    loadMoreButtonEl?.addEventListener('click', () => {
        showMoreRows();
    });
};


export default FeaturedListCards;
